export interface RemoteJob {
    id: string;
    title: string;
    description: string;
    status: string;
    type: number;
    salaryRangeStart: number;
    salaryRangeEnd: number;
    isHidden: boolean;
    isClosed: boolean;
    createdAt: string | Date;
    updatedAt: string | Date;
}

export interface SaveRemoteJobParam {
    id?: string;
    title: string;
    description: string;
    type: number;
    salaryRangeStart: number;
    salaryRangeEnd: number;
}

export const JOB_TYPE_OPTIONS = [
    { value: 1, label: '按月承揽全包' },
    { value: 2, label: '按月承揽半包' },
];

export const getJobTypeText = (type: number): string => {
    const option = JOB_TYPE_OPTIONS.find(item => item.value === type);
    return option ? option.label : '未知类型';
};

export const isJobActive = (job: RemoteJob): boolean => {
    return job.status === 'active' && !job.isClosed;
};

export const getJobStatusText = (job: RemoteJob): string => {
    return isJobActive(job) ? '招聘中' : '已下架';
};

export const formatSalaryRange = (start: number, end: number): string => {
    return `${start}-${end}K/月`;
};

export const createEmptyJobForm = (): SaveRemoteJobParam => ({
    title: '',
    description: '',
    type: 1,
    salaryRangeStart: 15,
    salaryRangeEnd: 25,
});
